import ActiveSmsModalBtn from "./ActiveSmsModalBtn";
import ActiveEmailModalBtn from "./ActiveEmailModalBtn";
import ActiveGoogleAuthModalBtn from "./ActiveGoogleAuthModalBtn";
import icons from "../../lib/icons";

const TwoFactorSettings = ({ twoFactorSettings }) => {
  const onFactorSetiingIsActive = twoFactorSettings.some(
    (e) => e.feildIsActive
  );

  const activeField = ({ name, feildIsActive }) => {
    switch (name) {
      case "sms_2fa":
        return (
          <ActiveSmsModalBtn
            feildIsActive={feildIsActive}
            onFactorSetiingIsActive={onFactorSetiingIsActive}
          />
        );
      case "email_2fa":
        return (
          <ActiveEmailModalBtn
            feildIsActive={feildIsActive}
            onFactorSetiingIsActive={onFactorSetiingIsActive}
          />
        );
      case "google_2fa":
        return (
          <ActiveGoogleAuthModalBtn
            feildIsActive={feildIsActive}
            onFactorSetiingIsActive={onFactorSetiingIsActive}
          />
        );
      default:
        return null; // Return null or a default fallback if the name doesn't match
    }
  };

  return (
    <div className="flex flex-col bg-primary-20 rounded-[12px] p-[10px] w-full gap-4">
      <div className="flex items-center gap-2">
        <div className="bg-[#E7E9EC] p-[10px] rounded-lg">
          <img
            src={icons.tow_step}
            alt="security-icon"
            width={16}
            height={16}
          />
        </div>
        <p className="flex-1 font-semibold text-[12px]">ورود دو مرحله‌ای</p>
      </div>
      <div className="flex flex-col gap-4 ">
        {twoFactorSettings.map(({ label, name, feildIsActive }) => (
          <div
            key={name}
            className="  flex gap-1 justify-between items-center border-b-[1px] border-neutral-30 py-2"
          >
            <span className="text-[14px]">{label}</span>

            {activeField({ name, feildIsActive })}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TwoFactorSettings;
